import { type FC, useState } from "react";
import { Button, Paper, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { CustomerNoteCategory } from "../../notes/customerNotesApi";
import { CustomerNoteFields } from "../../notes/CustomerNoteFields";
import { useAddCustomerNote } from "../../notes/useAddCustomerNote";
import { customerNoteCategoryLabels } from "./customerNoteCategoryLabels";

interface Props {
  customerId: string;
  onDone: () => void;
}

const categories: CustomerNoteCategory[] = ["PRZEZMORZE", "TRAVEL_PAY"];

const AddClientNoteForm: FC<Props> = ({ customerId, onDone }) => {
  const addNote = useAddCustomerNote(customerId);
  const [category, setCategory] = useState<CustomerNoteCategory>("PRZEZMORZE");
  const [noteType, setNoteType] = useState<string | null>(null);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const canSave = !saving && text.trim().length > 0;

  const save = async () => {
    if (!canSave) {
      return;
    }
    setSaving(true);
    try {
      await addNote({ text: text.trim(), type: noteType ?? undefined, category });
      onDone();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Paper variant="outlined" sx={{ p: 1.5 }}>
      <Stack spacing={1.5}>
        <ToggleButtonGroup
          exclusive
          size="small"
          color="primary"
          value={category}
          onChange={(_, value: CustomerNoteCategory | null) => {
            if (value) {
              setCategory(value);
            }
          }}
        >
          {categories.map((value) => (
            <ToggleButton key={value} value={value}>
              {customerNoteCategoryLabels[value]}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <CustomerNoteFields
          disabled={saving}
          noteType={noteType}
          text={text}
          onNoteTypeChange={setNoteType}
          onTextChange={setText}
          onSubmit={save}
        />
        <Stack direction="row" spacing={1} sx={{ justifyContent: "flex-end" }}>
          <Button onClick={onDone} disabled={saving}>
            Anuluj
          </Button>
          <Button variant="contained" onClick={save} disabled={!canSave}>
            Zapisz notatkę
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default AddClientNoteForm;
